import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ScenarioLocationService } from '@core/services/scenario-location.service';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';

interface MenuItem {
  name: string;
  icon: string;
  route: string;
  isExternal?: boolean;
}

@Component({
  selector: 'app-navigation-sidebar',
  templateUrl: './navigation-sidebar.component.html',
  styleUrls: ['./navigation-sidebar.component.scss'],
  standalone: true,
  imports: [IconComponent, TranslatePipe, RouterLink, DrawerModule],
})
export class NavigationSidebarComponent {
  public readonly scenario = inject(ScenarioLocationService);

  @Input({ required: true }) public sidebarOpen!: boolean;
  @Output() public onSidebarClose = new EventEmitter<void>();

  public menuItems: MenuItem[] = [
    {
      name: 'NAVIGATION.SIDEBAR.HOME',
      icon: 'map',
      route: '',
    },
    {
      name: 'NAVIGATION.SIDEBAR.DASHBOARD',
      icon: 'multiple-data-points',
      route: 'dashboard',
    },
    {
      name: 'NAVIGATION.SIDEBAR.INPUT_MEASUREMENTS',
      icon: 'waterbag-testkit',
      route: 'observation',
    },
    {
      name: 'NAVIGATION.SIDEBAR.FEEDBACK',
      icon: 'feedback',
      route: 'feedback',
    },
    {
      name: 'NAVIGATION.SIDEBAR.ABOUT',
      icon: 'info',
      route: 'about',
    },
  ];
}
